import { Info, Lock } from "lucide-react";

// Coin cash-out reference — informational only while Production cash-out stays disabled.
export default function VipCashoutInfo({ cashout }) {
  if (!cashout) return null;
  return (
    <section data-testid="vip-cashout-info" className="max-w-2xl">
      <div className="card-surface p-5 sm:p-6 border border-amber-500/30 flex flex-col gap-4">
        <div className="flex items-center gap-2 text-amber-200 text-[10px] uppercase tracking-[0.3em]"><Lock size={12} /> Creator cash-out · informational only · not active in Production</div>
        <h3 className="font-display text-2xl text-white">How coins would convert</h3>
        <dl className="grid grid-cols-2 gap-3 text-sm">
          <div className="border border-white/8 p-3"><dt className="text-[10px] uppercase tracking-widest text-zinc-500">Rate</dt><dd className="text-white mt-1" data-testid="vip-cashout-rate">{cashout.coins_per_usd.toLocaleString()} coins = $1.00</dd></div>
          <div className="border border-white/8 p-3"><dt className="text-[10px] uppercase tracking-widest text-zinc-500">Minimum</dt><dd className="text-white mt-1">{cashout.min_coins.toLocaleString()} coins</dd></div>
          <div className="border border-white/8 p-3 col-span-2"><dt className="text-[10px] uppercase tracking-widest text-zinc-500">Split (applied once)</dt><dd className="text-white mt-1" data-testid="vip-cashout-split">{cashout.platform_pct}% MyPandaX · {cashout.creator_pct}% creator</dd></div>
        </dl>
        <p className="text-xs text-zinc-400 leading-relaxed flex gap-2" data-testid="vip-cashout-note"><Info size={14} className="shrink-0 mt-0.5" /> {cashout.note}</p>
      </div>
    </section>
  );
}
